import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { RecordResponse } from '@/models/ServiceTypes';
import { WARootState } from './store';

export interface Classification {
  ClassificationId: number;
  Name: string;
  ParentId: number;
  IsAsset: boolean;
  Sort: number;
}

export const classificationsApi = createApi({
  reducerPath: 'classificationsApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getClassifications: builder.query<RecordResponse<Classification>, void>({
      queryFn: async (_args, { getState }, _extraOptions, baseQuery) => {
        const state = getState() as WARootState;
        const currentRole = state.auth.currentRole;

        const result = await baseQuery({
          url: `/api/${currentRole}/classifications`,
          method: 'GET',
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as RecordResponse<Classification> };
      },
    }),
  }),
});

export const { useGetClassificationsQuery } = classificationsApi;
